import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js/instance/sort';
import _Promise from '@babel/runtime-corejs3/core-js/promise';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default from 'react';
import { mobile, hooks, format } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { throttle } from 'lodash-es';
import useEvent from 'react-use/lib/useEvent';
import '../../../emotes/emote-panel.js';
import { EmoteContextProvider } from '../../../emotes/hooks/use-emotes.js';
import { Loading } from '../../../loading/index.js';
import { OpenAppBtn } from '../../../open-app-btn/index.js';
import { toggleToast } from '../../../toast/index.js';
import { replyToComment, addComment } from '../api/index.js';
import { ECommentType, ESortType } from '../enum.js';
import { useComments } from '../hooks/use-comments.js';
import useLockFn from '../hooks/use-lock-fn.js';
import useSwitch from '../hooks/use-switch.js';
import { isDarkTheme } from '../utils.js';
import { CommentItem } from './comment-item.js';
import { resolveOpenAppTarget } from './utils.js';

var _TARGET_TYPE_MAP;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var TARGET_TYPE_MAP = (_TARGET_TYPE_MAP = {}, _defineProperty(_TARGET_TYPE_MAP, ECommentType.Sound, 'sound'), _defineProperty(_TARGET_TYPE_MAP, ECommentType.Topic, 'topic'), _TARGET_TYPE_MAP);
var DEFAULT_MAX_RECOMMENDED_COMMENTS_NUM = 3;
var CommentsMobileInner = function CommentsMobileInner(props) {
  var type = props.type,
      eId = props.eId,
      enableRecommend = props.enableRecommend,
      _props$sort = _sortInstanceProperty(props),
      sort = _props$sort === void 0 ? ESortType.ByPublishTime : _props$sort,
      _props$maxRecommended = props.maxRecommendedCommentsNum,
      maxRecommendedCommentsNum = _props$maxRecommended === void 0 ? DEFAULT_MAX_RECOMMENDED_COMMENTS_NUM : _props$maxRecommended,
      _props$pagesize = props.pagesize,
      pagesize = _props$pagesize === void 0 ? 10 : _props$pagesize,
      titleRender = props.titleRender,
      className = props.className,
      openAppBtnRender = props.openAppBtnRender,
      onLike = props.onLike,
      subCommentsConfig = props.subCommentsConfig,
      hideIfNoComment = props.hideIfNoComment,
      _props$enableLoadingN = props.enableLoadingNotice,
      enableLoadingNotice = _props$enableLoadingN === void 0 ? true : _props$enableLoadingN;

  var isInApp = mobile.isMissEvanApp();
  var isInDarkTheme = isDarkTheme();

  var _hooks$useUser = hooks.useUser(),
      _hooks$useUser2 = _slicedToArray(_hooks$useUser, 2),
      currentUser = _hooks$useUser2[0],
      _hooks$useUser2$ = _hooks$useUser2[1],
      validateLogin = _hooks$useUser2$.validateLogin,
      withLoginRequired = _hooks$useUser2$.withLoginRequired;

  var _useComments = useComments(eId, type, {
    pageSize: pagesize,
    pageSizeForRecommendedComments: maxRecommendedCommentsNum,
    isRecommendationEnabled: enableRecommend !== null && enableRecommend !== void 0 ? enableRecommend : false,
    mode: 'infinite'
  }),
      commonComments = _useComments.commonComments,
      recommendedComments = _useComments.recommendedComments,
      totalCommentsNum = _useComments.totalCommentsNum,
      totalRecommendCommentsNum = _useComments.totalRecommendCommentsNum,
      loadPage = _useComments.loadPage,
      pagination = _useComments.pagination,
      insertComment = _useComments.insertComment,
      isCommentsLoading = _useComments.isLoading,
      hasMoreComments = _useComments.hasMoreComments;

  var _useLockFn = useLockFn(),
      loadingLock = _useLockFn.lockRef,
      lockLoading = _useLockFn.lock,
      unlockLoading = _useLockFn.unlock;

  var _useSwitch = useSwitch(true),
      _useSwitch2 = _slicedToArray(_useSwitch, 2),
      isInitialLoading = _useSwitch2[0],
      _useSwitch2$ = _useSwitch2[1],
      setInitialLoading = _useSwitch2$.on,
      clearInitialLoading = _useSwitch2$.off;

  var containerRef = React__default.useRef(null);
  var isLogged = validateLogin();
  var handleCheckLogin = withLoginRequired(function () {});
  var commentCompRefs = React__default.useRef({});
  var replyTarget = React__default.useRef(null);

  var _useLockFn2 = useLockFn(),
      withReplyLock = _useLockFn2.promiseWithLock;

  var replyInputRef = React__default.useRef(null);
  React__default.useEffect(function () {
    setInitialLoading();
    loadPage(1, sort).finally(clearInitialLoading); // setLoading, loadPage, clearLoading 不应加入 deps，会死循环
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eId, type, sort]);
  var THROTTLE_INTERVAL = 1000;
  var handleScroll = throttle(function () {
    if (!isInApp || !hasMoreComments || !containerRef.current) {
      return;
    }

    var scrollHeight = 80;

    var _containerRef$current = containerRef.current.getBoundingClientRect(),
        bottom = _containerRef$current.bottom;

    if (bottom - window.screen.height <= scrollHeight) {
      if (loadingLock.current) {
        return;
      }

      if (!isInitialLoading) {
        lockLoading();
        loadPage(pagination !== null && pagination !== void 0 && pagination.page ? (pagination === null || pagination === void 0 ? void 0 : pagination.page) + 1 : 1, sort).finally(unlockLoading);
      }
    }
  }, THROTTLE_INTERVAL);
  useEvent('scroll', handleScroll, window);
  var handleClickReply = withReplyLock(function () {
    var _replyInputRef$curren;

    if (!(currentUser !== null && currentUser !== void 0 && currentUser.bind)) {
      toggleToast('只有绑定手机才能评论哦~');
      return _Promise.resolve();
    }

    var comment = replyInputRef === null || replyInputRef === void 0 ? void 0 : (_replyInputRef$curren = replyInputRef.current) === null || _replyInputRef$curren === void 0 ? void 0 : _replyInputRef$curren.value;

    if (!comment) {
      return _Promise.resolve();
    }

    if (replyTarget.current) {
      var currReplyTarget = replyTarget.current;
      return replyToComment({
        comment_id: currReplyTarget.commentId,
        comment: comment
      }).then(function (data) {
        var commentIdToReply = currReplyTarget.commentId;
        var newReply = data.info;
        var commentCompRef = commentCompRefs.current[commentIdToReply];

        if (newReply && commentCompRef) {
          commentCompRef.insertSubComment(_objectSpread(_objectSpread({}, newReply), {}, {
            userid: newReply.user_id,
            ctime: format.formatRelativeTime(newReply.ctime * 1000)
          }));
        }

        currReplyTarget.value = '';
        replyTarget.current = null;
        var commentContainer = document.getElementById("comment-".concat(commentIdToReply));

        if (commentContainer) {
          commentContainer.scrollIntoView();
        }
      });
    } // 回复主题


    return addComment({
      type: type,
      eId: eId,
      comment: comment
    }).then(function (data) {
      var newComment = data.info;

      if (!newComment) {
        return;
      }

      var COMMENT_SUCCESS = '添加评论成功';
      toggleToast(COMMENT_SUCCESS);
      insertComment(_objectSpread(_objectSpread({}, newComment), {}, {
        subcomments: [],
        ctime: format.formatRelativeTime(newComment.ctime * 1000),
        userid: newComment.user_id,
        commentType: 'comment'
      }));

      if (!replyInputRef.current) {
        return;
      }

      replyInputRef.current.value = '';
    });
  });

  var handleToggleReply = function handleToggleReply(commentId, author) {
    if (!isInApp || !replyInputRef.current) {
      return;
    }

    var replyLeading = "\u56DE\u590D @".concat(author, " \uFF1A");
    replyInputRef.current.value = replyLeading;
    replyTarget.current = {
      commentId: commentId,
      value: ''
    };
    replyInputRef.current.focus();
    replyInputRef.current.setSelectionRange(replyLeading.length, replyLeading.length);
  };

  var renderComments = function renderComments() {
    var _resolveOpenAppTarget = resolveOpenAppTarget(type, eId),
        realType = _resolveOpenAppTarget.type,
        path = _resolveOpenAppTarget.path;

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, enableRecommend && recommendedComments && recommendedComments.length > 0 && /*#__PURE__*/React__default.createElement("div", {
      className: "recommend-content"
    }, _mapInstanceProperty(recommendedComments).call(recommendedComments, function (comment) {
      return /*#__PURE__*/React__default.createElement(CommentItem, {
        key: comment.id,
        type: "recommend",
        comment: comment,
        onToggleReply: handleToggleReply,
        onLike: onLike,
        subCommentsConfig: subCommentsConfig,
        ref: function ref(_ref) {
          commentCompRefs.current[comment.id] = _ref;
        }
      });
    }), totalRecommendCommentsNum > maxRecommendedCommentsNum ? /*#__PURE__*/React__default.createElement(OpenAppBtn, {
      type: realType,
      path: "".concat(path)
    }, /*#__PURE__*/React__default.createElement("span", {
      className: classNames('recommend-bottom', {
        more: totalRecommendCommentsNum > maxRecommendedCommentsNum
      })
    }, "\u66F4\u591A\u70ED\u95E8\u8BC4\u8BBA >")) : /*#__PURE__*/React__default.createElement("span", {
      className: "recommend-bottom"
    }, "\u4EE5\u4E0A\u4E3A\u70ED\u95E8\u8BC4\u8BBA")), commonComments && commonComments.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _mapInstanceProperty(commonComments).call(commonComments, function (comment) {
      return /*#__PURE__*/React__default.createElement(CommentItem, {
        key: comment.id,
        comment: comment,
        onToggleReply: handleToggleReply,
        onLike: onLike,
        subCommentsConfig: subCommentsConfig,
        ref: function ref(_ref2) {
          commentCompRefs.current[comment.id] = _ref2;
        }
      });
    }), !isInitialLoading && isCommentsLoading && enableLoadingNotice && /*#__PURE__*/React__default.createElement("div", {
      className: "loading-state"
    }, "\u6B63\u5728\u52A0\u8F7D..."), isInApp && !hasMoreComments && enableLoadingNotice && /*#__PURE__*/React__default.createElement("div", {
      className: "loading-state"
    }, "\u6CA1\u6709\u66F4\u591A\u8BC4\u8BBA")) : isInApp && /*#__PURE__*/React__default.createElement("div", {
      className: "comment none"
    }, "\u8FD8\u6CA1\u6709\u8BC4\u8BBA\uFF0C\u5FEB\u6765\u62A2\u6C99\u53D1\u5427~"));
  };

  if (hideIfNoComment && !(commonComments !== null && commonComments !== void 0 && commonComments.length)) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames('prelude-comments-m', className)
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: containerRef,
    className: classNames('comments', {
      app: isInApp,
      'dark-theme': isInDarkTheme
    })
  }, titleRender === null || titleRender === void 0 ? void 0 : titleRender(totalCommentsNum, isInitialLoading), isInApp && /*#__PURE__*/React__default.createElement("div", {
    className: classNames('reply', {
      'show-login': !isLogged
    }),
    onClick: handleCheckLogin
  }, /*#__PURE__*/React__default.createElement("textarea", {
    ref: replyInputRef,
    placeholder: isLogged ? '请输入评论内容~' : '请登录后评论 OwO',
    maxLength: 2000,
    readOnly: !isLogged
  }), /*#__PURE__*/React__default.createElement("button", {
    className: "btn-large btn-red",
    onClick: handleClickReply,
    disabled: !isLogged
  }, "\u8BC4\u8BBA")), isInitialLoading ? /*#__PURE__*/React__default.createElement(Loading, {
    className: "loading"
  }) : renderComments(), /*#__PURE__*/React__default.createElement("div", {
    className: "download-client"
  }, /*#__PURE__*/React__default.createElement(OpenAppBtn, {
    type: TARGET_TYPE_MAP[type],
    path: "".concat(eId)
  }, openAppBtnRender ? openAppBtnRender() : /*#__PURE__*/React__default.createElement("div", {
    className: "btn-larger btn-red btn-download-client"
  }, commonComments && commonComments.length ? '下载客户端，查看更多评论' : '下载客户端，发表第一条评论')))));
};
var CommentsMobile = function CommentsMobile(props) {
  return /*#__PURE__*/React__default.createElement(EmoteContextProvider, null, /*#__PURE__*/React__default.createElement(CommentsMobileInner, _objectSpread({}, props)));
};

export { CommentsMobile, CommentsMobileInner };
